import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiParameters } from 'src/app/configs/api.params';
import { IClientModel, IClients } from '../models/application.model';
import { IImagesModel } from '../models/image.model';


@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  constructor(private http: HttpClient) {}


  /**
   * This method adds new client
   * @param body - is client data entered in the form - e.g. (name: 'BMW', description: 'The company is located in Belgrade', customer: 'selected customer')
   * @returns Added client
   */
  add(body): Observable<IClientModel> {
    return this.http.post(apiParameters.url + '/clients', body)
      .pipe(map((res: IClientModel) => {
        return res;
      }));
  }

  /**
   * This method adds new client as a customer
   * @param body - is client data entered in the form - e.g. (name: 'BMW', description: 'The company is located in Belgrade', customer: 'selected customer')
   * @param customerId - customer id
   * @returns Added client
   */
  addClientAsCustomer(body, customerId: string): Observable<IClientModel> {
    return this.http.post<IClientModel>(apiParameters.url + '/customers/' + customerId + '/clients', body);
  }

  /**
   * This method update selected client
   * @param clientId - client id - e.g. (name: 'Audi', description: 'The company is located in NS', customer: 'selected customer')
   * @param body - the client data we have changed
   * @returns Updated client 
   */
  updateClient(clientId: string, body): Observable<IClientModel> {
    return this.http.patch<IClientModel>(`${apiParameters.url}/clients/${clientId}`, body);
  }

  /**
   * This method searches the client by name, email, country, city, address, post code
   * @param searchFields - array of object field e.g. [{"fieldNumber": 0,"fieldKey": "name","fieldValue": "test","button": "add"}]
   * @returns All filtered clients
   */
  getAll(page?: number, limit?: number, searchFields?: any,): Observable<IClients> {

    let httpOptions = {};
    page && limit
      ? httpOptions = {
        headers: new HttpHeaders({
          page: page.toString(),
          limit: limit.toString(),
        }),
        params: searchFields,
      }
      : httpOptions = {
        params: searchFields,
      };

    return this.http.get(apiParameters.url + '/clients', httpOptions)
      .pipe(
        map((res: IClients) => {
          return res;
        })
      );
  }

  /**
   * This method gets one client by id
   * @param applicationId - client id
   * @returns One client by id
   */
  getById(applicationId: string): Observable<IClientModel> {
    return this.http.get(apiParameters.url + '/clients/' + applicationId)
      .pipe(map((res: IClientModel) => {
        return res;
      }));
  }

  /**
   * Adds file
   * @param formData 
   * @param applicationId  - client id
   * @param type - e.g. logo or backgrounds
   * @returns  
   */
  addFile(formData: FormData, applicationId: string, type?: string) {
    let searchParams = new HttpParams();

    if (type && type !== '') {
      searchParams = searchParams.append('type', type);
    }

    const httpOptions = {
      reportProgress: true,
      params: searchParams
    };
    const url = apiParameters.url + '/clients/' + applicationId + '/files';
    return this.http.request(new HttpRequest('POST', url, formData, httpOptions));
    // return this.http.post(url, formData, httpOptions);
  }

  /**
   * Gets application files
   * @param applicationId - client id
   * @param type - e.g. logo or backgrounds
   * @returns Application files 
   */
  getApplicationFiles(applicationId: string, type: string): Observable<IImagesModel[]> {
    const typeText: string = '?type=' + type;

    return this.http.get(apiParameters.url + '/clients/' + applicationId + '/files' + typeText)
      .pipe(map((res: IImagesModel[]) => {
        return res;
      }));
  }

  /**
   * Deletes file
   * @param applicationId - client id
   * @param fileId - file id
   * @returns
   */
  deleteFile(applicationId: string, fileId: string): Observable<any> {
    return this.http.delete(apiParameters.url + '/clients/' + applicationId + '/files/' + fileId);
  }

  /**
   * Deletes application
   * @param appId - client id
   * @returns
   */
  deleteApplication(appId: string): Observable<any> {
    return this.http.delete(apiParameters.url + '/clients/' + appId);
  }

}
